import {
  ButtonText,
  Container,
  HeaderButton1,
  HeaderSection,
  HeaderSubTitle,
  ListContainer,
} from "../style";
import Header from "../../components/header";
import CreateBoardModal from "../../components/modals/createBoardModal";
import { CustomButton, StyledDivider } from "../../globalStyle";
import {
  LogoutButton,
  MemberSectionBlurImageWrapper,
  OverlayText,
  SettingsHeaderText,
  SettingsSectionWrapper1,
  SettingsSectionWrapper2,
} from "./style";
import AccountSettingsForm from "../../components/accountSettingsForm";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import routeConstant from "../../utils/routeConstant";
import ResetPasswordModal from "../../components/modals/resetPasswordModal";
import { logoutService } from "../../services/AuthServices";
import { AxiosResponse } from "axios";
import { Box, CircularProgress, Typography } from "@mui/material";
import { TeamSettingsForm } from "../../components/teamSettingsForm";
import { CreateNewIcon } from "../../assets/Icons";
import styled, { useTheme } from "styled-components";
import { MetaDataReducerAction } from "../../store/metadata/slice";
import { useDispatch, useSelector } from "react-redux";
import CreateTeamModal from "../../components/modals/createTeamModal";
import PlanSection from "../../components/planDetailsSection";
import { AccountSagaActions } from "../../store/account/sagas";
import { MetaDataSagaActions } from "../../store/metadata/sagas";
import { teamDetailsSelector } from "../../store/metadata/selector";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TeamSelectDropdown from "../../components/teamSelectDropdown";
import { PaymentReducerAction } from "../../store/payment/slice";
import { InviteMemberSection } from "../../components/InviteMemberSection";
import { userDetailsSelector } from "../../store/account/selector";
import { activeSubscriptionSelector } from "../../store/payment/selector";
import MemeberSectionImage from "../../assets/images/memeber-section.png";
import TeamMemberSectionImage from "../../assets/images/team-member-section.png";
import { UpgradePlanButton } from "../../components/planDetailsSection/style";

const ExitSectionWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "2rem",
  flexWrap: "wrap",
  backgroundColor: "#ffffff",
  border: "1px solid #f1f1f1",
  borderRadius: "20px",
  padding: "24px",
  marginTop: "24px",
  boxShadow: "0 6px 14px rgba(0,0,0,0.06)",
}));

const Settings = () => {
  const navigate = useNavigate();
  const userDetails = useSelector(userDetailsSelector);
  const activePlan = useSelector(activeSubscriptionSelector);
  const teamMembers = useSelector(teamDetailsSelector);
  // States
  const [logoutLoading, setLogoutLoading] = useState<boolean>(false);

  // Hooks
  const theme = useTheme();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { setAuthStatus } = useContext(AuthContext);

  // Variables
  const content = {
    tabTitle: "Account Settings",
    tabSubTitle: `Having trouble? Contact support through the live chat.`,
  };

  // Functions
  const handleLogoutRedirection = async () => {
    setLogoutLoading(true);
    const response = (await logoutService()) as AxiosResponse;
    if (response?.status === 200) {
      setAuthStatus(false);
      setLogoutLoading(false);
      localStorage.clear();
      navigation(`/${routeConstant.login}`, {
        replace: true,
      });
    } else {
      setLogoutLoading(false);
    }
  };

  const handleChangeTeam = (teamId: string) => {
    dispatch(MetaDataSagaActions.changeTeam({ teamId }));
  };

  useEffect(() => {
    dispatch(MetaDataSagaActions.teamDetails());
    dispatch(AccountSagaActions.getPlanLists());
    dispatch(PaymentReducerAction.resetSubscriptionSkipLimitValue());
  }, []);

  const handleRedirect = () => {
    navigate(`${routeConstant.subscription}`);
  };

  const AccountDetails = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.875rem",
        }}
      >
        <SettingsSectionWrapper1>
          <SettingsSectionWrapper2>
            <SettingsHeaderText>Account Details</SettingsHeaderText>
            <HeaderSubTitle>Update your Account information.</HeaderSubTitle>
            <StyledDivider sx={{ margin: "20px 0 40px" }} />
            <AccountSettingsForm />
          </SettingsSectionWrapper2>
          <LogoutButton
            onClick={handleLogoutRedirection}
            disabled={logoutLoading}
            startIcon={
              logoutLoading && <CircularProgress size={20} color="inherit" />
            }
          >
            Logout
          </LogoutButton>
        </SettingsSectionWrapper1>

        {userDetails ? (
          userDetails?.planId ? (
            activePlan?.activePlanDetails.planType === "Free" ? (
              <SettingsSectionWrapper1>
                <MemberSectionBlurImageWrapper
                  src={MemeberSectionImage}
                  alt=""
                />
                <OverlayText>
                  Please upgrade to access this feature.
                  <br />
                  <UpgradePlanButton
                    onClick={handleRedirect}
                    style={{ marginTop: "1rem" }}
                  >
                    Upgrade Plan
                  </UpgradePlanButton>
                </OverlayText>
              </SettingsSectionWrapper1>
            ) : (
              <SettingsSectionWrapper1>
                <SettingsSectionWrapper2>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SettingsHeaderText>Members</SettingsHeaderText>
                    <HeaderButton1
                      variant="outlined"
                      size="large"
                      sx={{ width: "200px" }}
                      onClick={() => navigate(routeConstant?.purchaseSeatLogs)}
                    >
                      <ReceiptIcon />
                      <ButtonText>Seat History</ButtonText>
                    </HeaderButton1>
                  </Box>
                  <HeaderSubTitle>
                    Here you can invite members to your team.
                  </HeaderSubTitle>
                  <StyledDivider sx={{ margin: "20px 0 40px" }} />
                  <InviteMemberSection />
                </SettingsSectionWrapper2>
              </SettingsSectionWrapper1>
            )
          ) : !(
              typeof userDetails?.isInvitedBySeat === "string" &&
              userDetails?.isInvitedBySeat
            ) ? (
            // ✅ No planId but not invited → still show section
            activePlan?.activePlanDetails.planType === "Free" ? (
              <SettingsSectionWrapper1>
                <MemberSectionBlurImageWrapper
                  src={MemeberSectionImage}
                  alt=""
                />
                <OverlayText>
                  Please upgrade to access this feature.
                  <br />
                  <UpgradePlanButton
                    onClick={handleRedirect}
                    style={{ marginTop: "1rem" }}
                  >
                    Upgrade Plan
                  </UpgradePlanButton>
                </OverlayText>
              </SettingsSectionWrapper1>
            ) : (
              <SettingsSectionWrapper1>
                <SettingsSectionWrapper2>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SettingsHeaderText>Members</SettingsHeaderText>
                    <HeaderButton1
                      variant="outlined"
                      size="large"
                      sx={{ width: "200px" }}
                      onClick={() => navigate(routeConstant?.purchaseSeatLogs)}
                    >
                      <ReceiptIcon />
                      <ButtonText>Seat History</ButtonText>
                    </HeaderButton1>
                  </Box>
                  <HeaderSubTitle>
                    Here you can invite members to your team.
                  </HeaderSubTitle>
                  <StyledDivider sx={{ margin: "20px 0 40px" }} />
                  <InviteMemberSection />
                </SettingsSectionWrapper2>
              </SettingsSectionWrapper1>
            )
          ) : null
        ) : null}

        {activePlan?.activePlanDetails.planType === "Free" ? (
          <SettingsSectionWrapper1>
            <MemberSectionBlurImageWrapper
              src={TeamMemberSectionImage}
              alt=""
            />
            <OverlayText>
              Please upgrade to access this feature.
              <br />
              <UpgradePlanButton
                onClick={handleRedirect}
                style={{ marginTop: "1rem" }} // adds spacing
              >
                Upgrade Plan
              </UpgradePlanButton>
            </OverlayText>
          </SettingsSectionWrapper1>
        ) : (
          <SettingsSectionWrapper1>
            <SettingsSectionWrapper2>
              <SettingsHeaderText>Team Settings</SettingsHeaderText>
              <HeaderSubTitle>
                Let's get started by adding members to your team.
              </HeaderSubTitle>
              <StyledDivider sx={{ margin: "20px 0 40px" }} />
              <TeamSettingsForm />
            </SettingsSectionWrapper2>
            {teamMembers?.length > 0 && (
              <TeamSelectDropdown
                onChange={handleChangeTeam}
                sx={{
                  position: "absolute",
                  top: "1.875rem",
                  right: "27.188rem",
                  borderRadius: "1.563rem",
                  border: "1px solid transparent",
                  background:
                    "linear-gradient(white, white) padding-box, linear-gradient(135deg, #1c75bc, #00aeef) border-box", // Add gradient border
                  margin: "0",
                  marginRight: "1rem",
                  "& .MuiInputBase-input": {
                    padding: "0.625rem 1.25rem !important",
                    paddingRight: "2rem !important",
                    background: "linear-gradient(135deg, #1c75bc, #00aeef)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    borderRadius: "1.563rem",
                    border: "1px solid transparent",
                  },
                  "& .MuiSelect-icon": {
                    right: "0.5rem",
                    color: "#00aeef",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiMenuItem-root": {
                    padding: "0.25rem 0.5rem !important",
                  },
                  "& .MuiList-padding": {
                    padding: "0 !important",
                  },
                }}
              />
            )}

            {userDetails?.parentPlanDetails?.parentDeatils?._id ? null : (
              <CustomButton
                variant="contained"
                size="small"
                sx={{
                  position: "absolute",
                  top: "1.875rem",
                  right: "16.188rem",
                  padding: "0.625rem 1.25rem",
                  fontSize: "1rem",
                  fontWeight: "500",
                  borderRadius: "1.786rem !important",
                  color: "white !important",
                  background: `${theme.colors.backgroundPrimary} !important`,
                  height: "2.6rem",
                  cursor: "pointer",
                }}
                onClick={() =>
                  dispatch(MetaDataReducerAction.setOpenCreateTeamModal(true))
                }
              >
                <CreateNewIcon fill="white" />
                <ButtonText>Create Team</ButtonText>
              </CustomButton>
            )}
          </SettingsSectionWrapper1>
        )}

        {userDetails ? (
          userDetails?.planId ? (
            // ✅ Always show if planId exists
            <SettingsSectionWrapper1>
              <SettingsSectionWrapper2>
                <SettingsHeaderText>My Plans</SettingsHeaderText>
                <HeaderSubTitle>
                  For user Subscriptions History and Renewal.
                </HeaderSubTitle>
                <StyledDivider sx={{ margin: "20px 0 40px" }} />
                <PlanSection />
              </SettingsSectionWrapper2>

              <CustomButton
                variant="contained"
                size="small"
                sx={{
                  position: "absolute",
                  top: "1.875rem",
                  right: "16.188rem",
                  padding: "0.625rem 1.25rem",
                  fontSize: "1rem",
                  fontWeight: "500",
                  borderRadius: "1.786rem !important",
                  color: "white !important",
                  background: `${theme.colors.backgroundPrimary} !important`,
                  height: "2.6rem",
                }}
                onClick={() => {
                  navigation(`${routeConstant.paymentHistory}`);
                }}
              >
                <ButtonText>View Payment History</ButtonText>
              </CustomButton>
            </SettingsSectionWrapper1>
          ) : !(
              typeof userDetails?.isInvitedBySeat === "string" &&
              userDetails?.isInvitedBySeat
            ) ? (
            // ✅ Show only if NOT invited user
            <SettingsSectionWrapper1>
              <SettingsSectionWrapper2>
                <SettingsHeaderText>My Plans</SettingsHeaderText>
                <HeaderSubTitle>
                  For user Subscriptions History and Renewal.
                </HeaderSubTitle>
                <StyledDivider sx={{ margin: "20px 0 40px" }} />
                <PlanSection />
              </SettingsSectionWrapper2>

              <CustomButton
                variant="contained"
                size="small"
                sx={{
                  position: "absolute",
                  top: "1.875rem",
                  right: "16.188rem",
                  padding: "0.625rem 1.25rem",
                  fontSize: "1rem",
                  fontWeight: "500",
                  borderRadius: "1.786rem !important",
                  color: "white !important",
                  background: `${theme.colors.backgroundPrimary} !important`,
                  height: "2.6rem",
                }}
                onClick={() => {
                  navigation(`${routeConstant.paymentHistory}`);
                }}
              >
                <ButtonText>View Payment History</ButtonText>
              </CustomButton>
            </SettingsSectionWrapper1>
          ) : null
        ) : null}

        {userDetails &&
          typeof userDetails?.isInvitedBySeat === "string" &&
          userDetails?.isInvitedBySeat && (
            <SettingsSectionWrapper1>
              <SettingsSectionWrapper2>
                <SettingsHeaderText>Workspace Membership</SettingsHeaderText>
                <StyledDivider sx={{ margin: "20px 0 30px" }} />

                <ExitSectionWrapper>
                  {userDetails?.parentPlanDetails?.parentDeatils?.fullName &&
                  userDetails?.parentPlanDetails?.parentDeatils?.email ? (
                    <>
                      {/* Left side: Avatar + Details */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1rem",
                          flex: "0 0 auto",
                        }}
                      >
                        {/* Avatar with gradient background */}
                        <Box
                          sx={{
                            width: 56,
                            height: 56,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg, #1c75bc, #00aeef)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontWeight: "700",
                            fontSize: "1.2rem",
                            textTransform: "uppercase",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                          }}
                        >
                          {userDetails.parentPlanDetails.parentDeatils.fullName.charAt(
                            0
                          )}
                        </Box>

                        {/* Name + Email */}
                        <Box>
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 700, color: "#222" }}
                          >
                            {
                              userDetails.parentPlanDetails.parentDeatils
                                .fullName
                            }
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ color: "#666", fontSize: "0.9rem" }}
                          >
                            {userDetails.parentPlanDetails.parentDeatils.email}
                          </Typography>

                          {/* Small badge */}
                          <Box
                            sx={{
                              marginTop: "6px",
                              display: "inline-block",
                              background:
                                "linear-gradient(135deg, #1c75bc, #00aeef)",
                              color: "#fff",
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              padding: "4px 12px",
                              borderRadius: "999px",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                              letterSpacing: "0.3px",
                            }}
                          >
                            Team Owner
                          </Box>
                        </Box>
                      </Box>

                      {/* Right side: Message */}
                      <Box
                        sx={{
                          flex: 1,
                          minWidth: "220px",
                          textAlign: "right",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#333",
                            fontSize: "0.95rem",
                            lineHeight: 1.6,
                          }}
                        >
                          🎉 You’ve successfully accepted{" "}
                          <strong>
                            {
                              userDetails.parentPlanDetails.parentDeatils
                                .fullName
                            }
                          </strong>
                          ’s invitation. Start collaborating.
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <Typography variant="body1" sx={{ color: "#444" }}>
                      🎉 You have successfully joined this workspace as part of
                      the team.
                    </Typography>
                  )}
                </ExitSectionWrapper>
              </SettingsSectionWrapper2>
            </SettingsSectionWrapper1>
          )}
        <ResetPasswordModal />
        <CreateTeamModal />
      </div>
    );
  };

  return (
    <Container>
      <HeaderSection>
        <Header content={content} hideCreateButton={true} />
        <ListContainer>
          <AccountDetails />
        </ListContainer>
      </HeaderSection>
      <CreateBoardModal />
    </Container>
  );
};

export default Settings;
